import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { task, timeout } from 'ember-concurrency';
import noUiSlider from 'nouislider';
import { next } from '@ember/runloop';
import { registerDestructor } from '@ember/destroyable';
import { tracked } from '@glimmer/tracking';

export default class DeluxePlayerVolumeComponent extends Component {
  @service stereo;
  @service playback;
  @service session;
  @service fetch;
  @service intl;

  @tracked isDestroying = false;

  slider = null;
  sliderElement = null;

  constructor() {
    super(...arguments);
    registerDestructor(this, () => {
      this.isDestroying = true;
      if (this.slider) {
        this.slider.off('start');
        this.slider.off('slide');
        this.slider.off('drag');
        this.slider.off('update');
        this.slider.off('change');
        this.slider.off('set');
        this.slider.off('end');
        this.slider.destroy();
      }
    });
    this.monitorExternalVolumeChanges.perform();
  }

  initializeSlider() {
    this.slider = noUiSlider.create(this.sliderElement, {
      keyboardSupport: true,
      keyboardDefaultStep: 5,
      range: {
        min: 0,
        max: 100,
      },
      connect: 'lower',
      behavior: 'tap-drag-all',
      padding: 0,
      start: [this.stereo.volume],
      cssPrefix: 'dubbletrack-slider-',
    });

    this.slider.enable();
    this.slider.on('update', this.onSliderUpdate.bind(this));
  }

  @action
  onExternalUpdate(handle, value) {
    if (this.slider && !this.isDestroying) {
      next(() => {
        this.slider.setHandle(handle, value, false);
      });
    }
  }

  monitorExternalVolumeChanges = task(async () => {
    while (true) {
      await timeout(200);
      if (
        this.slider &&
        !this.isDestroying &&
        this.stereo.volume != this.slider.get()
      ) {
        next(() => {
          this.slider.setHandle(0, this.stereo.volume, false);
        });
      }
    }
  });

  onSliderUpdate(values, handle) {
    let volume = values[handle];
    this.stereo.volume = volume;
  }

  @action
  async didInsert(element) {
    this.sliderElement = element;
    if (this.slider) {
      this.slider.destroy();
    }
    this.initializeSlider();
  }
}
